export enum ZohoType {
  DATE_TIME = 'DateTime',
  DATE = 'Date',
  PHONE = 'Phone',
}
